<template>
  <div :class="['nav-wrapper', className, { 'nav-menu-open': menuOpen }]">
    <div class="frame-30">
      <div class="frame-31">
        <RouterLink to="/" class="frame-32-link" aria-label="Accueil">
          <img
            class="frame-32"
            alt="Florisuite"
            src="https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
          />
        </RouterLink>

        <button
          type="button"
          class="nav-toggle"
          aria-label="Menu"
          :aria-expanded="menuOpen"
          @click="menuOpen = !menuOpen"
        >
          <span class="nav-toggle-bar"></span>
          <span class="nav-toggle-bar"></span>
          <span class="nav-toggle-bar"></span>
        </button>

        <div class="frame-33">
          <RouterLink class="text-wrapper-15" to="/" @click="menuOpen = false">
            Accueil
          </RouterLink>
          <RouterLink class="text-wrapper-16" to="/fonctionnalites" @click="menuOpen = false">
            Fonctionnalités
          </RouterLink>
          <RouterLink class="text-wrapper-16" to="/tarifs" @click="menuOpen = false">
            Tarifs
          </RouterLink>
          <RouterLink class="text-wrapper-16" to="/contact" @click="menuOpen = false">
            Contact
          </RouterLink>
        </div>
        <div class="frame-34">
          <RouterLink to="/connexion" class="button-2" @click="menuOpen = false">
            <div class="text-wrapper-17">Se connecter</div>
          </RouterLink>
          <RouterLink to="/inscription" class="d-marrer-l-essai-wrapper" @click="menuOpen = false">
            <div class="d-marrer-l-essai-2">Essai gratuit</div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "NavWrapper",
  components: {
    RouterLink,
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      required: true,
    },
  },
  data() {
    return { menuOpen: false };
  },
});
</script>

<style>
.nav-wrapper {
  align-items: center;
  background-color: #ffffff;
  border: 0px none;
  box-shadow: 0px 0px 0px transparent, 0px 0px 2px #171a1f1f;
  display: flex;
  flex-direction: column;
  gap: 21px;
  min-height: 69px;
  justify-content: center;
  overflow: hidden;
  padding: 18px 32px;
  position: relative;
  width: 100%;
  max-width: 100%;
}

.nav-wrapper .frame-30 {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 0;
  height: auto;
  justify-content: stretch;
  margin: 0;
  position: relative;
  width: 100%;
}

.nav-wrapper .frame-31 {
  align-items: center;
  display: flex;
  flex: 1;
  flex-grow: 1;
  justify-content: space-between;
  position: relative;
}

.nav-wrapper .frame-32 {
  position: relative;
  width: 234px;
}

.nav-wrapper .frame-32-link {
  display: block;
  line-height: 0;
}

.nav-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 32px;
  height: 32px;
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin-left: auto;
}

.nav-toggle-bar {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #084734;
  border-radius: 1px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.nav-menu-open .nav-toggle .nav-toggle-bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.nav-menu-open .nav-toggle .nav-toggle-bar:nth-child(2) {
  opacity: 0;
}

.nav-menu-open .nav-toggle .nav-toggle-bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.nav-wrapper .frame-33 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 30px;
  position: relative;
}

.nav-wrapper .text-wrapper-15 {
  color: #084734;
  display: block;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.nav-wrapper .text-wrapper-16 {
  color: #5f5f5f;
  display: block;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.nav-wrapper .text-wrapper-16:hover {
  color: #084734;
}

.nav-wrapper .frame-34 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
}

.nav-wrapper .button-2 {
  all: unset;
  align-items: center;
  border: 0px none;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  width: 110px;
}

.nav-wrapper .text-wrapper-17 {
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-align: center;
  white-space: nowrap;
}

.nav-wrapper .d-marrer-l-essai-wrapper {
  background-color: #084734;
  border: 0px none;
  border-radius: 6px;
  box-shadow: 0px 0px 0px transparent, 0px 1px 2px #0000000d;
  height: 40px;
  overflow: hidden;
  position: relative;
  width: 110px;
}

.nav-wrapper .d-marrer-l-essai-2 {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  left: calc(50.00% - 42px);
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  text-align: center;
  top: calc(50.00% - 11px);
  white-space: nowrap;
}

@media (max-width: 1024px) {
  .nav-wrapper {
    padding: 12px 16px;
  }

  .nav-wrapper .frame-31 {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .nav-wrapper .frame-32 {
    width: 180px;
    max-width: 50vw;
  }

  .nav-wrapper .nav-toggle {
    display: flex;
  }

  .nav-wrapper .frame-33,
  .nav-wrapper .frame-34 {
    display: none !important;
    width: 100%;
    flex-basis: 100%;
  }

  .nav-wrapper.nav-menu-open .frame-33,
  .nav-wrapper.nav-menu-open .frame-34 {
    display: flex !important;
  }

  .nav-wrapper.nav-menu-open .frame-33 {
    flex-direction: column;
    gap: 12px;
    padding: 16px 0 8px;
    order: 3;
    border-top: 1px solid #eee;
    margin-top: 8px;
  }

  .nav-wrapper.nav-menu-open .frame-34 {
    flex-direction: column;
    gap: 12px;
    order: 4;
    padding-bottom: 8px;
  }

  .nav-wrapper.nav-menu-open .frame-34 .button-2,
  .nav-wrapper.nav-menu-open .frame-34 .d-marrer-l-essai-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-wrapper.nav-menu-open .d-marrer-l-essai-2 {
    position: static;
  }
}
</style>
